<template>
  <section class="intro saving">
    <div class="contain">
      <img class="icon loader" src="@/assets/img/loader.svg" />
      <h1>
        {{ title }}
        <span class="dot">...</span>
      </h1>
      <p>{{ body }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Section",
  props: ["title", "body", "next"],
  components: {},
  data() {
    return {};
  },
  mounted() {},
  created() {},
  firestore() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>

<style scoped lang="scss">
.intro {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  text-align: center;
  min-height: 100vh !important;
  &.saving {
    position: fixed;
    z-index: 2;
    top: 0;
    background: rgba(255, 255, 255, 0.95);
  }
  .contain {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    max-width: 700px;
    .icon {
      height: 70px;
      margin-bottom: 30px;
      &.loader {
        -webkit-animation: loader infinite 2s;
      }
    }
    h1 {
      font-size: 50px;
    }
  }
}

@-webkit-keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
